import {
    emailRegex,
    numberOnlyRegex,
    textOnlyRegex
} from './regex'
const employment_typeList = [
    'Full-time',
    'Part-time',
    'Magang',
    'Kontrak'
]
const listMonth = [
    { number: 1, text: "Januari" },
    { number: 2, text: "Februari" },
    { number: 3, text: "Maret" },
    { number: 4, text: "April" },
    { number: 5, text: "Mei" },
    { number: 6, text: "Juni" },
    { number: 7, text: "July" },
    { number: 8, text: "Agustus" },
    { number: 9, text: "September" },
    { number: 10, text: "Oktober" },
    { number: 11, text: "November" },
    { number: 12, text: "Desember" }
]
const listDegree = [
                {name: 'S1'},
                {name: 'S2'},
                {name: 'S3'}
            ]
const listLevel = [
    { name: 'Tingkat Dasar' },
    { name: 'Tingkat Menengah' },
    { name: 'Tingkat Profesional' },
    { name: 'Tingkat Profesional Mahir' },
    { name: 'Tingkat Fasih atau Bahasa Asli' }
]

const submissionStatus = [
    { id: null, name: "Semua Status", class: 'black'},
    {id: 0, name: 'Lamaran Terkirim', class: 'primary'},
    {id: 1, name: 'Lamaran Sedang Direview', class: 'secondary'},
    {id: 2, name: 'Lamaran Diterima', class: 'success'},
    {id: 9, name: 'Lamaran Ditolak', class: 'error'},
]
const submissionStatusCompany = [
    { id: null, name: "Semua Status", class: 'black'},
    {id: 0, name: 'Baru', class: 'primary'},
    {id: 1, name: 'Review', class: 'secondary'},
    {id: 2, name: 'Diterima', class: 'success'},
    {id: 9, name: 'Ditolak', class: 'error'},
]
const listIcon = [
    'behance',
    'dribbble',
    'facebook',
    'github',
    'instagram',
    'linkedin',
    'twitter',
    'website',
    'youtube',
    'line',
    'whatsapp',
    'telegram'
]
const getFirstName = (name) => {
    if(name == null) return null
    var temp = name.split(" ")
    for(let i = 0 ; i < temp.length ; i++){
        if(temp[i] == ''){
            continue
        }else{
            return temp[i]
        }
    }
} 
const getInisial = (name,count = 2) => {
    if(name == null) return "JF"
    var temp = name.split(" ")
    var result = ''
    for(let i = 0 ; i < temp.length ; i++){
        if(i == count) break
        if(temp[i] == ''){
            continue
        }else{
            result += temp[i][0]
        }
    }
    return result
} 

async function validateForm(field,item,error,errorMsg, regexValidate = []){
    
    var countError = 0
    for (var i = 0; i < field.length; i++){
        if(item[field[i]] == null || item[field[i]] == ''){
            error[field[i]] = true
            errorMsg[field[i]] = 'Tidak boleh kosong'
            countError += 1;
        }else{
            error[field[i]] = false
        }
    }
    if(regexValidate.length == 0){
        return {countError, error, errorMsg}
    }else{
        return validateRegex(regexValidate,item,error,errorMsg,countError)
    }
}
async function validateRegex(field,item,error,errorMsg,countError){
    const temp = {
        email: {
            regex: emailRegex,
            msg: 'Email tidak valid'
        },
        numberOnly:{
            regex: numberOnlyRegex,
            msg: 'Hanya boleh angka'
        },
        textOnly:{
            regex: textOnlyRegex,
            msg: 'Hanya boleh huruf'
        }
    }
    for (var i = 0; i < field.length; i++){
        if(!error[field[i].name]){
            if(!RegExp(temp[field[i].regex].regex).test(item[field[i].name])){
                error[field[i].name] = true
                errorMsg[field[i].name] = temp[field[i].regex].msg
                countError += 1;
            }else{
                error[field[i].name] = false
            }
        }
    }
    return {countError, error, errorMsg}
}
function isEmpty(value){
    return value == null || value == ''
}

function getMonthName(value){
    if(value == null) return null
    return listMonth.find(row => {
        return row.number == value
    }).text
}

function getSubmissionStatus(value, type = 'jobseeker'){
    if(type == 'jobseeker'){
        return submissionStatus.find(row => {
            return row.id == value
        })
    }else{
        return submissionStatusCompany.find(row => {
            return row.id == value
        })
    }
}
function generateVideoId(value){
    if(value == null) return null
    let videoId = null;
    if(value.toLowerCase().includes('?v=')){
        videoId = value.split('?v=')[1]
    }else if(value.toLowerCase().includes('youtu.be/')){
        videoId = value.split('youtu.be/')[1]
    }
    return videoId
}
function countProgress(user){
    const userDetail = user.detail || {}
    const education = userDetail?.educations?.length > 0 ? 25 : 0
    const works = userDetail?.works?.length > 0 ? 5 : 0
    const social_medias = userDetail?.social_medias?.length > 0 ? 5 : 0
    const skills = userDetail?.skills?.length > 0 ? 5 : 0
    const files = userDetail?.files?.length > 0 ? 5 : 0
    const description = userDetail?.description != null ? 5 : 0
    const detail = userDetail?.phone_number != null ? 30 : 0
    const profile_picture = userDetail?.profile_picture != null ? 20 : 0

    const total = parseInt(education) 
                    + parseInt(works) 
                    + parseInt(social_medias) 
                    + parseInt(skills) 
                    + parseInt(files) 
                    + parseInt(detail) 
                    + parseInt(description) 
                    + parseInt(profile_picture)
    return total
}

export {
    getFirstName,
    getInisial,
    validateForm,
    validateRegex,
    listMonth,
    isEmpty,
    getMonthName,
    listDegree,
    employment_typeList,
    getSubmissionStatus,
    submissionStatus,
    listIcon,
    generateVideoId,
    countProgress,
    listLevel
}